import React from 'react'

import Expanded from './Expanded'
import Collapsed from './Collapsed'

const PrimaryMenu = ({ currentUser, logOutPath, avatarUrl, menuItems }) => {
  return <Expanded {...{ currentUser, logOutPath, avatarUrl, menuItems }} />
}

export default PrimaryMenu
